import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
class EntityCreatedData extends Component {
    handleEditEntityDetails = (entityData) => {
        this.props.entityCreatedDataCallback(entityData);
    }
    deleteUserDetails = (event, entityData) => {
        this.props.deleteUserData(entityData);
    }
    render() {
        return (
            <div>
                <Row noGutters className="mb-3 custom-table-header d-none d-sm-flex align-items-center">
                    <Col sm="7" className="custom-table-header-title px-2 py-3">Company Name</Col>
                    <Col sm="4" className="custom-table-header-title px-2 py-3">City </Col>
                    <Col sm="7" className="custom-table-header-title px-2 py-3 d-flex align-items-center cursor-pointer">GST Number</Col>
                    <Col sm="6" className="custom-table-header-title px-2 py-3  cursor-pointer" title="Risk Level">PAN Number</Col>
                    {/* <Col sm="4" className="custom-table-header-title px-2 py-3 text-sm-center cursor-pointer" title="Risk Level">Action</Col> */}
                </Row>
                <ul className="border-bottom mb-4">
                    <li>
                        <Row noGutters className="mb-3 custom-table-col d-none d-sm-flex align-items-center">
                            <Col sm="7" className="custom-table-col px-2 py-3 cursor-pointer"><a onClick={() => this.handleEditEntityDetails(this.props.entityFormData)}><span>{this.props.entityFormData.correspondentEntityName}</span></a></Col>
                            <Col sm="4" className="custom-table-col px-2 py-3">{this.props.entityFormData.city} </Col>
                            <Col sm="7" className="custom-table-col px-2 py-3  d-flex align-items-center">{this.props.entityFormData.gstNum}</Col>
                            <Col sm="6" className="custom-table-col px-2 py-3" title={this.props.entityFormData.panNo}>{this.props.entityFormData.panNo}</Col>
                            {/* <Col sm="4" className="custom-table-col px-2 py-3 text-sm-center cursor-pointer" title="Risk Level" onClick={() => this.deleteUserDetails(this.props.entityFormData)}><Button className="btn-transparent p-0 shadow-none"><i className="icon-close text-danger"></i></Button></Col> */}
                        </Row>
                        {/* <Row>
                            <Col xs="5" className="d-flex align-items-center px-2 py-3"><a onClick={() => this.handleEditEntityDetails(this.props.entityFormData)}><span>{this.props.entityFormData.correspondentEntityName}</span></a></Col>
                            <Col xs="4" className="d-flex align-items-center px-2 py-3"><span>{this.props.entityFormData.address}</span></Col>
                            <Col xs="6" className="d-flex align-items-center text-break px-2 py-3"><span>{this.props.entityFormData.gstNum}</span></Col>
                            <Col xs="5" className="d-flex align-items-center px-2 py-3"><span>{this.props.entityFormData.panNo}</span></Col>
                            <Col xs="4" className="text-center d-flex align-items-center px-2 py-3" onClick={() => this.deleteUserDetails(this.props.entityFormData)}><Button className="btn-transparent p-0 shadow-none"><i className="icon-close text-danger"></i></Button></Col>
                        </Row> */}
                    </li>
                </ul>
            </div>
        )
    }
}

export default EntityCreatedData;